/** Does nothing */
export const NOOP = () => {}